const admin = [
    {
        name : 'Mr. Adam',
        username : 'admin1',
        Level_admin : 'Super Admin',
        phone_number : '08123456789',
        email : 'Adm_SA@example.com',
        address : 'Jl. Jalan 1',
        
    },
    {
        name : 'Mr. Adam',
        username : 'admin1',
        Level_admin : 'Back Office',
        phone_number : '08123456789',
        email : 'adm_SPV@example.com',
        address : 'Jl. Jalan 2',
        
    },
    {
        name : 'Mr. Adam',
        username : 'admin1',
        Level_admin : 'Resepsionis',
        phone_number : '08123456789',
        email : 'adm_RS@example.com',
        address : 'Jl. Jalan 3',
        
    },
    {
        name : 'Mr. Adam',
        username : 'admin1',
        Level_admin : 'Back Office',
        phone_number : '08123456789',
        email : 'adm_BOf@example.com',
        address : 'Jl. Jalan 4',
        
    },
    {
        name : 'Mr. Adam',
        username : 'admin1',
        Level_admin : 'House Keeping',
        phone_number : '08123456789',
        email : 'adm_HK@example.com',
        address : 'Jl. Jalan 5',
        
    },
    {
        name : 'Mr. Adam',
        username : 'admin1',
        Level_admin : 'Maintenance',
        phone_number : '08123456789',
        email : 'adm_MT@example.com',
        address : 'Jl. Jalan 6',
        
    },

]

export default admin